module.exports = __webpack_public_path__ + "img/Pro-4.03cda467.jpg";